export class StorageKeyConstants {
  static readonly LANGUAGE_CODE = 'languageCode';
  static readonly LANGUAGE_KEY = 'language';
  static readonly NEWS_FEED_APP_QUERY = 'news-feed-app';
}
